import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MovieData } from "../../entry/server/movie.ts";
import { videoRepo } from "../../repo/video-repo.ts";
import { AppContext } from "../../context/app-context.tsx";
import AdminPageTitle from "../admin-pages/admin-page-title.tsx";
import { Pagination } from "../../lib/api.ts";
import PaginationView from "../../componrnts/pagination.tsx";

function getMovieTypeLabel(type: string) {
  switch (type) {
    case "movie":
      return "فیلم";
    case "series":
      return "سریال";
    case "animation":
      return "انیمیشن";
    case "anime":
      return "انیمه";
    default:
      return type;
  }
}

export default function MoviesList() {
  const [movies, setMovies] = useState<MovieData[]>([]);
  const [pagination, setPagination] = useState<Pagination | null>(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [searchInput, setSearchInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const { setMessage } = useContext(AppContext);

  useEffect(() => {
    const fetchMovies = async () => {
      setLoading(true);
      try {
        const response = await videoRepo.getMovies(page, searchQuery || undefined);
        if (!response.status || !response.data) {
          setMessage({ type: "error", message: response.message || "دریافت لیست فیلم‌ها ناموفق بود." });
          setMovies([]);
          return;
        }
        setMovies(response.data);
        setPagination(response.pagination || null);
      } catch {
        setMessage({ type: "error", message: "خطا در ارتباط با سرور. دوباره تلاش کنید." });
        setMovies([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMovies();
  }, [page, searchQuery, setMessage]);

  const onSearchSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    setPage(1);
    setSearchQuery(searchInput.trim());
  };

  const totalItems = pagination?.total_items;

  return (
    <section className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <AdminPageTitle title="فیلم‌ها" />
        {typeof totalItems === "number" ? (
          <p className="rounded-xl border border-slate-800 bg-slate-900/60 px-4 py-2 text-sm text-slate-300">
            تعداد: <span className="font-medium text-slate-100">{totalItems.toLocaleString("fa-IR")}</span>
          </p>
        ) : null}
      </div>

      <form onSubmit={onSearchSubmit} className="flex flex-col gap-2 sm:flex-row sm:items-end">
        <label className="flex-1 space-y-2">
          <span className="text-sm text-slate-300">جستجو</span>
          <input
            value={searchInput}
            onChange={(event) => setSearchInput(event.target.value)}
            placeholder="عنوان یا نام فارسی..."
            className="w-full rounded-lg border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-100 outline-none transition focus:border-indigo-400"
          />
        </label>
        <button
          type="submit"
          className="rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-indigo-400"
        >
          جستجو
        </button>
      </form>

      {loading ? (
        <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-6 text-slate-300">
          در حال دریافت لیست فیلم‌ها...
        </div>
      ) : !movies.length ? (
        <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-6 text-slate-300">
          فیلمی یافت نشد.
        </div>
      ) : (
        <>
          <div className="overflow-x-auto rounded-2xl border border-slate-800 bg-slate-900/60">
            <table className="min-w-full divide-y divide-slate-800 text-sm">
              <thead className="bg-slate-900/80">
                <tr>
                  <th className="px-4 py-3 text-right font-medium text-slate-300">شناسه</th>
                  <th className="px-4 py-3 text-right font-medium text-slate-300">عنوان</th>
                  <th className="px-4 py-3 text-right font-medium text-slate-300">عنوان فارسی</th>
                  <th className="px-4 py-3 text-right font-medium text-slate-300">نوع</th>
                  <th className="px-4 py-3 text-right font-medium text-slate-300">عملیات</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-800">
                {movies.map((movie) => (
                  <tr key={movie.id} className="transition hover:bg-slate-900">
                    <td className="whitespace-nowrap px-4 py-3 text-slate-300">{movie.id}</td>
                    <td className="px-4 py-3 text-slate-100">{movie.title}</td>
                    <td className="px-4 py-3 text-slate-300">{movie.fa_title || "-"}</td>
                    <td className="whitespace-nowrap px-4 py-3 text-slate-300">{getMovieTypeLabel(movie.type)}</td>
                    <td className="px-4 py-3">
                      <Link
                        to={`/admin/movies/${movie.id}`}
                        className="inline-flex rounded-lg border border-indigo-700 px-3 py-1.5 text-xs text-indigo-200 transition hover:border-indigo-500 hover:text-indigo-300"
                      >
                        جزئیات
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {pagination && <PaginationView pagination={pagination} onPageChange={setPage} />}
        </>
      )}
    </section>
  );
}
